module.exports = __webpack_public_path__ + "static/introducing-1d47d49b93b8b57f242cfdfa9bf202d0.png";